// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, func, string } from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { handlePathsImport } from 'redux/modules/projectSummary'
import { PATH_DATABASE_IMPORT } from 'components/ProjectSummary/ModalContainer/ImportWrapper/constants'

const buttonClasses = 'btn search-button big-button display-block create-button'

class Import extends React.Component {
  static propTypes = {
    handlePathsImport: func.isRequired,
    highlightedRows: array.isRequired,
    idRoot: string.isRequired,
  }

  importHighlightedPaths = () => {
    const {
      handlePathsImport,
      highlightedRows,
    } = this.props

    if (!highlightedRows.length) {
      return
    }

    return handlePathsImport(highlightedRows, PATH_DATABASE_IMPORT)
  }

  render () {
    const {
      highlightedRows,
      idRoot,
    } = this.props

    return (
      <a
        id={`${idRoot}import`}
        className={`${buttonClasses} ${(!highlightedRows.length ? 'cursor-not-allowed bg-grey-dark' : 'bg-blue')}`}
        onClick={this.importHighlightedPaths}>
        {'Import'}
      </a>
    )
  }
}

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    handlePathsImport,
  }, dispatch)
)

export default connect(
  () => ({}),
  mapDispatchToProps
)(Import)
